import { variables, $ } from '../common/variables';
import { cl, ajax } from '../common/functions';


const inputFile = () => {
  let fileInputs = document.querySelectorAll(`.bootstrap-scope input[type="file"]`);
  if (fileInputs.length !== 0) {
    [...fileInputs].forEach(fileInput => {
      let parentElement = fileInput.parentNode;
      if (parentElement !== null) {
        fileInput.addEventListener('change', (e) => {
          let value = fileInput.value.replace(/^.*[\\/]/, '');
          if (value !== null) {
            parentElement.setAttribute("title", value);
          }
        });
      }
    });
  }
}

export { inputFile }
